var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("resizable-common-dialog", {
    ref: "dialog",
    attrs: {
      title: "Import JSON",
      "dialog-visible": _vm.visible,
      rules: "rules",
      "start-dialog-height": "360",
      "start-dialog-width": "350",
    },
    on: {
      "update:dialogVisible": function ($event) {
        _vm.visible = $event
      },
      "update:dialog-visible": function ($event) {
        _vm.visible = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("v-spacer"),
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c("v-col", { staticClass: "pa-0" }, [
                  _c("strong", [_vm._v("UID: ")]),
                  _c("strong", [_vm._v(_vm._s(_vm.config?.uid))]),
                ]),
              ],
              1
            ),
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c("v-col", { staticClass: "pa-0" }, [
                  _c("strong", [_vm._v("Group: ")]),
                  _c("strong", [_vm._v(_vm._s(_vm.config?.group))]),
                ]),
              ],
              1
            ),
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c("v-col", { staticClass: "pa-0" }, [
                  _c("strong", [_vm._v("Tag: ")]),
                  _c("strong", [_vm._v(_vm._s(_vm.config?.tag))]),
                ]),
              ],
              1
            ),
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c("v-file-input", {
                  ref: "uploaderJson",
                  attrs: {
                    accept: "application/json",
                    label: "Import from JSON file",
                    "show-size": "",
                  },
                  on: { change: _vm.onFileChangedJson },
                  model: {
                    value: _vm.file,
                    callback: function ($$v) {
                      _vm.file = $$v
                    },
                    expression: "file",
                  },
                }),
              ],
              1
            ),
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c("v-alert", { attrs: { type: "warning", dense: "" } }, [
                  _vm._v(
                    " Warning: Importing configuration will overwrite all data from config. "
                  ),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              "v-btn",
              {
                attrs: { color: "blue darken-1", text: "" },
                on: { click: _vm.hide },
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "v-btn",
              {
                attrs: { color: "blue darken-1", text: "" },
                on: { click: _vm.importConfiguration },
              },
              [_vm._v("Import")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }